// chat-story 编辑器：participants + messages(sender选参与者/text/time) 增删。
import { useTranslation } from 'react-i18next'
import type { EditorContext } from '../_shared/types'
import type { ChatData } from './types'
import { Field, TextInput, TextArea, Repeater, RemoveButton } from '../../components/editor-controls'

export function ChatStoryEditor({ data, update }: EditorContext) {
  const { t } = useTranslation()
  const d = data as unknown as ChatData
  const participants = d.participants || []
  const messages = d.messages || []
  return (
    <>
      <Field label={t('editor.storyTitle')}>
        <TextInput value={d.title ?? ''} onChange={(v) => update((dd) => { dd.title = v })} />
      </Field>
      <Field label={t('editor.participantsCount', { count: participants.length })}>
        {participants.map((p, i) => (
          <div className="editable-item" key={i}>
            <span className="ei-rank">{i + 1}</span>
            <TextInput
              value={p}
              placeholder={t('editor.participantN', { n: i + 1 })}
              onChange={(v) => update((dd) => { dd.participants[i] = v })}
            />
            <RemoveButton onRemove={() => update((dd) => { dd.participants.splice(i, 1) })} />
          </div>
        ))}
        <Repeater addLabel={t('editor.participant')} onAdd={() => update((dd) => { dd.participants.push('') })} />
      </Field>
      <Field label={t('editor.messagesCount', { count: messages.length })} hint={t('editor.messagesHint')}>
        {messages.map((m, i) => (
          <div className="editable-item col" key={i}>
            <div className="editable-item">
              <span className="ei-rank">{i + 1}</span>
              <select
                className="select"
                value={m.sender}
                style={{ flex: 1 }}
                onChange={(e) => update((dd) => { dd.messages[i].sender = +e.target.value })}
              >
                {participants.length === 0 && <option value={0}>{t('editor.participantEmptyHint')}</option>}
                {participants.map((p, pi) => (
                  <option key={pi} value={pi}>
                    {pi}: {p || t('editor.participantN', { n: pi + 1 })}
                  </option>
                ))}
              </select>
              <RemoveButton onRemove={() => update((dd) => { dd.messages.splice(i, 1) })} />
            </div>
            <TextArea
              value={m.text}
              rows={2}
              placeholder={t('editor.textPh')}
              onChange={(v) => update((dd) => { dd.messages[i].text = v })}
            />
            <TextInput
              value={m.time}
              placeholder={t('editor.timePlaceholder')}
              mono
              onChange={(v) => update((dd) => { dd.messages[i].time = v })}
            />
          </div>
        ))}
        <Repeater
          addLabel={t('editor.message')}
          onAdd={() => update((dd) => { dd.messages.push({ sender: 0, text: '', time: '' }) })}
        />
      </Field>
    </>
  )
}
